import { ISourceReferable } from "./ISourceReferable";

export class SourceReader<TSource> implements ISourceReferable<TSource> {
  constructor(public readonly _source: TSource) {}

  public getSource(): TSource {
    return this._source;
  }

  public isReferedSameSource(instance: ISourceReferable<TSource>): boolean {
    return (this.getSource() === instance.getSource());
  }

  public get<T>(get: (s: TSource) => T): T {
    return get(this._source);
  }

  public getOrDefault<T>(get: (s: TSource) => T, defaultValue: T): T {
    return this._source
      ? get(this._source)
      : defaultValue;
  }
}
